import React from 'react';
import PropTypes from 'prop-types';

import Slider from '../../slider/Slider';
import iconReturns from '../../../../assets/svg/icon-returns.svg';
import iconStar from '../../../../assets/svg/icon-star.svg';
import iconGlobe from '../../../../assets/svg/icon-globe.svg';

const TrustIndicators = ({indicators}) => {
  const icons = {
    returns: iconReturns,
    star: iconStar,
    globe: iconGlobe,
  };

  let slidesId = '';
  const slides = indicators.map((item) => {
    slidesId += `trust-${item.text}`;
    return (
      <div className="trust-indicator" key={`trust-${item.text}`}>
        <div class="trust-indicator__icon" dangerouslySetInnerHTML={{__html: icons[item.icon]}} />
        <div class="trust-indicator__text h9" dangerouslySetInnerHTML={{__html: item.text}} />
      </div>
    );
  });

  return (
    <div className="trust-indicators">
      <Slider
        slidesId={slidesId}
        flickityConfig={{
          draggable: slides.length > 1,
          prevNextButtons: false,
          pageDots: false,
          fade: true,
          autoPlay: true,
        }}
        classPrefix="trust-indicators"
      >
        {slides}
      </Slider>
    </div>
  );
};

TrustIndicators.propTypes = {
  indicators: PropTypes.arrayOf(PropTypes.object),
};

export default TrustIndicators;
